import { z } from 'zod';
export const userDirectoryListFunctionName = 'userDirectoryList';
export const userDirectoryGetRequestParamsSchema = z.object({
    accountId: z.string(),
});
